import httpService from '@/services/core/http.service';

class SystemStatusService {
    route = 'system-status';

    // customCatch keeps a red service from firing the global error toast on every poll.
    get = (refresh = false, cancelToken = null) => httpService.get(this.route, { refresh }, { cancelToken, customCatch: true });
}

export default new SystemStatusService();
